import React from "react";
import DummyChart from "../../../components/DummyChart";

/**
 * Metric card with optional subscribe lock (Go Pro / DummyChart style).
 * Blurred preview chart + readable name/numbers + centered Subscribe overlay.
 */
export default function ArtistManagerMetricCard({
    locked = false,
    lockIcon = null,
    lockLabel = "",
    lockPreviewValue = "—",
    lockChartType = "area",
    lockChartHeight = 200,
    showLockCta = false,
    showLinkArtistCta = false,
    onSubscribe,
    onLinkArtist,
    children,
}) {
    const cardClass =
        "info-box relative flex h-full flex-col justify-between gap-2 overflow-hidden rounded-xl bg-white p-4 font-manrope 2xl:p-5";

    if (!locked) {
        return <div className={cardClass}>{children}</div>;
    }

    const showCta = showLockCta || showLinkArtistCta;

    return (
        <div className={cardClass}>
            <DummyChart
                variant="metricCard"
                icon={lockIcon}
                chartType={lockChartType}
                chartHeight={lockChartHeight}
                topText={lockPreviewValue}
                bottomText={lockLabel}
                onProClick={showLinkArtistCta ? onLinkArtist : onSubscribe}
                showCta={showCta}
                ctaLabel={showLinkArtistCta ? "Link Your Artist" : "Subscribe to unlock"}
                showCtaIcon={!showLinkArtistCta}
                compactCta
            />
        </div>
    );
}
